<div
  fxLayout="row"
  fxLayoutAlign="space-between center"
  class="ngx-breadcrumb-container"
>
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <ng-container *ngIf="breadcrumbs$ | async as breadcrumbs">
        <ng-container
          *ngFor="
            let breadcrumb of breadcrumbs;
            last as isLast;
            first as isFirst
          "
        >
          <li *ngIf="breadcrumb.label" class="breadcrumb-item">
            <ng-container
              [ngTemplateOutlet]="breadcrumbTemplate || defaultTemplate"
              [ngTemplateOutletContext]="{
                breadcrumbArr: breadcrumbs,
                breadcrumb: breadcrumb,
                isLast: isLast,
                isFirst: isFirst
              }"
            ></ng-container>
          </li>
        </ng-container>
      </ng-container>
    </ol>
  </nav>
</div>

<ng-template #defaultTemplate let-breadcrumb="breadcrumb" let-isLast="isLast">
  <a
    href="javascript:void(0)"
    *ngIf="breadcrumb.isClickable"
    (click)="navigateTo(breadcrumb.url)"
    title="{{breadcrumb.tooltip}}"
  >
    {{ breadcrumb.label }}
  </a>
  <span *ngIf="!isLast" class="breadcrumb-separator">/</span>
</ng-template>
